// Utility function to build query parameters, excluding empty values
export const buildQueryParams = (
  params?: Record<string, string | number | boolean | undefined | null>
): string => {
  if (!params) return '';
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    // Only include parameters that are not undefined, null, or empty strings
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};
